import { Component, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { SafeResourceUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import Quill from 'quill';
import { GoogleAccountService } from 'src/app/services/google-account.service';
import { LocalService } from 'src/app/services/local.service';
import { PuzzleService } from 'src/app/services/puzzle.service';
import { ResponseDialogComponent } from '../response-dialog/response-dialog.component';
import { ResponseSmallDialogComponent } from '../response-small-dialog/response-small-dialog.component';
import { Candidate } from 'src/app/interfaces/Candidate';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { QuillEditorComponent } from 'ngx-quill';

export function descriptionRequiredValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    // si hay un img o video no se valida
    if (control.value?.includes('<img') || control.value?.includes('<video')) {
      return null;
    }
    const cleanedContent = control.value?.replace(/<[^>]*>/g, '').trim();
    return cleanedContent && cleanedContent.length > 0
      ? null
      : { required: true };
  };
}

@Component({
  selector: 'app-share-candidates-dialog',
  templateUrl: './share-candidates-dialog.component.html',
  styleUrls: ['./share-candidates-dialog.component.css'],
})
export class ShareCandidatesDialogComponent implements OnInit {
  sending: boolean = false;
  usuariosFiltrados = [];
  usuariosFiltrados2 = [];
  usuariosFiltrados3 = [];
  allUsers = [];
  pageSize = 1000;
  pageIndex = 0;
  id: string;
  selectedUsers = [];
  selectedUsers2 = [];
  selectedUsers3 = [];
  selectedCandidates = [];
  currentUser: string;
  emptyUsers: boolean = false;
  editSubjectMode: boolean = false;
  companyLogoRoute: string = '';
  editIcon: SafeResourceUrl = '../../../assets/icons/edit-icon.svg';
  closeIcon: SafeResourceUrl = '../../assets/icons/close-icon.svg';
  miFormulario: FormGroup;
  subject: string;
  userSearchControl = new FormControl();
  userSearchControl2 = new FormControl();
  userSearchControl3 = new FormControl();
  totalUsers: number = 0;
  googleAccount: boolean = false;
  microsoftAccount: boolean = false;
  isAdvanced: boolean = false;
  editorOptions = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ size: ['small', false, 'large', 'huge'] }],
      [{ font: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['clean'],
      ['image'],
    ],
  };
  activeCC: boolean = false;
  isMini: boolean = false;
  selectedCVType: string = '';
  userPermissions: string[];
  includeReport: boolean = false;
  showCVClient: boolean = false;
  isRestoringContent: boolean = false; // Bandera para evitar ciclos infinitos
  errorEmail: boolean = false;
  quillInstance: Quill; // Para guardar la instancia de Quill
  @ViewChild('select1') select1: MatSelect;
  @ViewChild('select2') select2: MatSelect;
  @ViewChild('select3') select3: MatSelect;
  @ViewChild('selectCVType') selectCVType: MatSelect;
  @ViewChild('quillEditor') quillEditor!: QuillEditorComponent;

  constructor(
    public dialog: MatDialog,
    private translate: TranslateService,
    private puzzleService: PuzzleService,
    private localService: LocalService,
    private renderer: Renderer2,
    private fb: FormBuilder,
    private google: GoogleAccountService,
    private dialogRef: MatDialogRef<ShareCandidatesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.selectedCandidates = data.selectedCandidates; // Recibir los candidatos seleccionados
    this.subject = data.subject;

    this.miFormulario = this.fb.group({
      subject: [this.subject, Validators.required],
      message: ['', [descriptionRequiredValidator()]],
    });

    let tokencito = this.localService.getJsonValue('token');
    if (tokencito.data.companyId != null) {
      this.id = tokencito.data.companyId;
      this.companyLogoRoute = tokencito.data.compLogoRoute;
    }
    this.isAdvanced = tokencito.data.isAdvanced;
    this.isMini = tokencito.data.isMiniCompany;

    this.userPermissions = tokencito?.data?.permissions.map(
      (permission) => permission.code,
    );

    this.currentUser = tokencito.data.id.toLowerCase();
    this.showCVClient = tokencito.data?.companyCvClient;
  }

  ngOnInit(): void {
    this.miFormulario = this.fb.group({
      message: ['', [descriptionRequiredValidator()]],
      subject: [{ value: this.subject, disabled: true }, [Validators.required]], // Inyectar el subject y deshabilitar por defecto
    });
    this.getUsers();
    this.getGoogleAccount();

    if (this.selectCVType) {
      this.selectCVType.value = 'CV';
    }
  }

  getUsers(): void {
    this.puzzleService
      .getAllUsers(
        this.pageSize,
        this.pageIndex,
        null,
        'Activos',
        this.id,
        null,
        true,
      )
      .subscribe(
        (users) => {
          this.allUsers = users.map((user) => ({
            id: user.id.toLowerCase(),
            nombre: user.anU_FULL_NAME,
            email: user.email,
          }));

          //ordenar por nombre
          this.allUsers.sort((a, b) => a.nombre.localeCompare(b.nombre));

          // quitar si ya se selecciono
          this.usuariosFiltrados = this.allUsers.filter(
            (usuario) =>
              !this.selectedUsers.find(
                (selectedUser) => selectedUser.id === usuario.id,
              ),
          );

          this.usuariosFiltrados2 = this.allUsers.filter(
            (usuario) =>
              !this.selectedUsers2.find(
                (selectedUser) => selectedUser.id === usuario.id,
              ) && usuario.id !== this.currentUser,
          );

          this.usuariosFiltrados3 = this.allUsers.filter(
            (usuario) =>
              !this.selectedUsers3.find(
                (selectedUser) => selectedUser.id === usuario.id,
              ) && usuario.id !== this.currentUser,
          );

          /* if (this.usuariosFiltrados.length === 0) {
            // close dialog and show message
            this.dialogRef.close({
              isSuccess: false,
              message: 'noUsersAvailable',
            });
          } */

          const usersAux = this.usuariosFiltrados;
          const usersAux2 = this.usuariosFiltrados2;
          const usersAux3 = this.usuariosFiltrados3;
          this.totalUsers = this.usuariosFiltrados.length;

          this.userSearchControl.valueChanges.subscribe((search) => {
            this.usuariosFiltrados = usersAux.filter((element) =>
              `${element.nombre} (${element.email})`
                .toLowerCase()
                .includes(search?.toLowerCase() || ''),
            );
          });

          this.userSearchControl2.valueChanges.subscribe((search) => {
            this.usuariosFiltrados2 = usersAux2.filter((element) =>
              `${element.nombre} (${element.email})`
                .toLowerCase()
                .includes(search?.toLowerCase() || ''),
            );
          });

          this.userSearchControl3.valueChanges.subscribe((search) => {
            this.usuariosFiltrados3 = usersAux3.filter((element) =>
              `${element.nombre} (${element.email})`
                .toLowerCase()
                .includes(search?.toLowerCase() || ''),
            );
          });
        },
        (error) => {},
      );
  }

  shareCandidates() {
    if (this.sending) {
      return;
    }
    this.miFormulario.markAllAsTouched();
    if (this.miFormulario.invalid || this.selectedUsers.length === 0) {
      if (this.selectedUsers.length === 0) {
        this.emptyUsers = true;
      }
      return;
    }

    if (!this.isMini) {
      this.selectedCVType = 'CV';
    }

    if (this.getPermission('X01') && this.showCVClient) {
      this.selectedCVType = 'CV_CLIENTS';
    }

    if (!this.showCVClient) {
      this.selectedCVType = 'CV';
    }

    if (!this.selectedCVType && this.isMini) {
      this.openResponseDialog(
        'Error',
        this.translate.instant('CV_CLIENTS_Error'),
      );
      return;
    } else if (!this.selectedCVType) {
      this.selectedCVType = 'CV';
    }

    if (!this.miFormulario.get('subject').value || this.miFormulario.get('subject').value.trim() === '') {
      this.editSubjectMode = true;
      this.miFormulario.get('subject').enable();
      this.openResponseDialog(
        'Error',
        this.translate.instant('subjectRequired'),
      );
      return;
    }

    this.sending = true;

    if (!this.googleAccount && !this.microsoftAccount) {
      const data = {
        candidatesIds: this.selectedCandidates.map((candidate) => ({
          candidateId: candidate.cdT_ID,
          candidateName: `${candidate.cdT_NAME} ${candidate.cdT_PATERNAL_SURNAME} ${candidate.cdT_MATERNAL_SURNAME}`,
          cv: this.selectCV(candidate, this.selectedCVType),
          CandidateReport: this.includeReport
            ? this.selectCV(candidate, 'CANDIDATE_REPORT')
            : null,
        })),
        userList: this.selectedUsers,
        message: this.miFormulario.get('message').value,
        subject: this.miFormulario.get('subject').value,
        companyLogoRoute: this.companyLogoRoute,
        companyId: this.id,
      };
      this.puzzleService.shareCandidatesMail(data).subscribe((response) => {
        this.dialogRef.close({
          isSuccess: response.isSuccess,
          message: response.message,
        });
      });
    } else {
      const gmailData = {
        candidatesIds: this.selectedCandidates.map((candidate) => ({
          candidateId: candidate.cdT_ID,
          candidateName: `${candidate.cdT_NAME} ${candidate.cdT_PATERNAL_SURNAME} ${candidate.cdT_MATERNAL_SURNAME}`,
          cv: this.selectCV(candidate, this.selectedCVType),
          CandidateReport: this.includeReport
            ? this.selectCV(candidate, 'CANDIDATE_REPORT')
            : null,
        })),
        userList: this.selectedUsers,
        message: this.miFormulario.get('message').value,
        subject: this.miFormulario.get('subject').value,
        companyLogoRoute: this.companyLogoRoute,
        companyId: this.id,
        cc: this.selectedUsers2,
        bcc: this.selectedUsers3,
      };

      if (this.googleAccount) {
        this.puzzleService
          .shareCandidatesGmail(gmailData)
          .subscribe((response) => {
            this.dialogRef.close({
              isSuccess: response.isSuccess,
              message: response.message,
            });
          });
      } else if (this.microsoftAccount) {
        this.puzzleService
          .shareCandidatesOutlook(gmailData)
          .subscribe((response) => {
            this.dialogRef.close({
              isSuccess: response.isSuccess,
              message: response.message,
            });
          });
      }
    }
  }

  getGoogleAccount() {
    this.puzzleService.checkGoogleAccount().subscribe((response) => {
      if (response.isSuccess) {
        this.googleAccount = response.data.hasGmailAccount;
        this.microsoftAccount = response.data.hasOutlookAccount;
      }
    });
  }

  closeModal() {
    this.dialogRef.close();
  }

  toggleEditSubject() {
    this.editSubjectMode = !this.editSubjectMode;

    if (this.editSubjectMode) {
      // Habilitar el campo subject
      this.miFormulario.get('subject').enable();
    } else {
      // Deshabilitar el campo subject
      this.miFormulario.get('subject').disable();
    }

    if (!this.miFormulario.get('subject').value || this.miFormulario.get('subject').value.trim() === '') {
      this.editSubjectMode = true;
      this.miFormulario.get('subject').enable();
      this.openResponseDialog(
        'Error',
        this.translate.instant('subjectRequired'),
      );
      return;
    }
  }

  selectCV(candidate: Candidate, cvType: string) {
    switch (cvType) {
      case 'CV':
        return candidate?.cv?.cdoC_DOCUMENT_ROUTE;
      case 'CV_CLIENTS':
        return candidate?.candidateCVClient?.clienT_CDOC_DOCUMENT_ROUTE;
      case 'CANDIDATE_REPORT':
        return candidate?.candidateReportDocument?.reporT_CDOC_DOCUMENT_ROUTE;
    }
  }

  onIncludeReportChange(event: MatCheckboxChange) {
    this.includeReport = event.checked;
  }

  onParticipantSelected(event: MatSelectChange) {
    let user = event.value;
    // si es texto, se arma el objeto
    if (typeof user === 'string') {
      // validar si es un email valido
      if (!this.validateEmail(user)) {
        this.openResponseDialog(
          'Error',
          this.translate.instant('invalidEmail'),
        );
        if (this.select1) {
          this.select1.value = null;
          this.select1.writeValue(null);
          if (this.select1?.ngControl?.control) {
            this.select1.ngControl.control.setValue(null, { emitEvent: false });
          }
        }
        return;
      }

      const userAux = {
        id: user.toLowerCase(),
        nombre: user,
        email: user,
      };
      user = userAux;
    }
    // checar si ya esta seleccionado
    const index = this.selectedUsers.findIndex(
      (selectedUser) => selectedUser.email === user.email,
    );
    if (index === -1) {
      this.selectedUsers.push(user);
      this.usuariosFiltrados = this.usuariosFiltrados.filter(
        (usuario) => usuario.email !== user.email,
      );
    }

    this.updateFilteredUsersByEmail();

    if (this.select1) {
      this.select1.value = null;
      this.select1.writeValue(null);
      if (this.select1?.ngControl?.control) {
        this.select1.ngControl.control.setValue(null, { emitEvent: false });
      }
    }
  }

  updateFilteredUsersByEmail() {
    this.usuariosFiltrados = this.allUsers.filter(
      (usuario) =>
        !this.selectedUsers.find(
          (selectedUser) => selectedUser.email === usuario.email,
        ),
    );

    this.usuariosFiltrados2 = this.allUsers.filter(
      (usuario) =>
        !this.selectedUsers2.find(
          (selectedUser) => selectedUser.email === usuario.email,
        ),
    );

    this.usuariosFiltrados3 = this.allUsers.filter(
      (usuario) =>
        !this.selectedUsers3.find(
          (selectedUser) => selectedUser.email === usuario.email,
        ),
    );

    const usersAux = this.usuariosFiltrados;
    const usersAux2 = this.usuariosFiltrados2;
    const usersAux3 = this.usuariosFiltrados3;

    this.userSearchControl.valueChanges.subscribe((search) => {
      this.usuariosFiltrados = usersAux.filter((element) =>
        `${element.nombre} (${element.email})`
          .toLowerCase()
          .includes(search?.toLowerCase() || ''),
      );
    });

    this.userSearchControl2.valueChanges.subscribe((search) => {
      this.usuariosFiltrados2 = usersAux2.filter((element) =>
        `${element.nombre} (${element.email})`
          .toLowerCase()
          .includes(search?.toLowerCase() || ''),
      );
    });

    this.userSearchControl3.valueChanges.subscribe((search) => {
      this.usuariosFiltrados3 = usersAux3.filter((element) =>
        `${element.nombre} (${element.email})`
          .toLowerCase()
          .includes(search?.toLowerCase() || ''),
      );
    });
  }

  onParticipantSelected2(event: MatSelectChange) {
    let user = event.value;
    // si es texto, se arma el objeto
    if (typeof user === 'string') {
      // validar si es un email valido
      if (!this.validateEmail(user)) {
        this.openResponseDialog(
          'Error',
          this.translate.instant('invalidEmail'),
        );
        if (this.select2) {
          this.select2.value = null;
          this.select2.writeValue(null);
          if (this.select2?.ngControl?.control) {
            this.select2.ngControl.control.setValue(null, { emitEvent: false });
          }
        }
        return;
      }

      const userAux = {
        id: user.toLowerCase(),
        nombre: user,
        email: user,
      };
      user = userAux;
    }
    // checar si ya esta seleccionado
    const index = this.selectedUsers2.findIndex(
      (selectedUser) => selectedUser.email === user.email,
    );
    if (index === -1) {
      this.selectedUsers2.push(user);
      this.usuariosFiltrados2 = this.usuariosFiltrados2.filter(
        (usuario) => usuario.email !== user.email,
      );
    }

    this.updateFilteredUsersByEmail();

    if (this.select2) {
      this.select2.value = null;
      this.select2.writeValue(null);
      if (this.select2?.ngControl?.control) {
        this.select2.ngControl.control.setValue(null, { emitEvent: false });
      }
    }
  }

  onParticipantSelected3(event: MatSelectChange) {
    let user = event.value;
    // si es texto, se arma el objeto
    if (typeof user === 'string') {
      // validar si es un email valido
      if (!this.validateEmail(user)) {
        this.openResponseDialog(
          'Error',
          this.translate.instant('invalidEmail'),
        );
        if (this.select3) {
          this.select3.value = null;
          this.select3.writeValue(null);
          if (this.select3?.ngControl?.control) {
            this.select3.ngControl.control.setValue(null, { emitEvent: false });
          }
        }
        return;
      }

      const userAux = {
        id: user.toLowerCase(),
        nombre: user,
        email: user,
      };
      user = userAux;
    }
    // checar si ya esta seleccionado
    const index = this.selectedUsers3.findIndex(
      (selectedUser) => selectedUser.email === user.email,
    );
    if (index === -1) {
      this.selectedUsers3.push(user);
      this.usuariosFiltrados3 = this.usuariosFiltrados3.filter(
        (usuario) => usuario.email !== user.email,
      );
    }

    this.updateFilteredUsersByEmail();

    if (this.select3) {
      this.select3.value = null;
      this.select3.writeValue(null);
      if (this.select3?.ngControl?.control) {
        this.select3.ngControl.control.setValue(null, { emitEvent: false });
      }
    }
  }

  removeUser(user) {
    this.selectedUsers = this.selectedUsers.filter(
      (selectedUser) => selectedUser.id !== user.id,
    );
    this.usuariosFiltrados.push(JSON.parse(JSON.stringify(user)));
    //ordenar por nombre
    this.usuariosFiltrados.sort((a, b) => a.nombre.localeCompare(b.nombre));
  }

  removeUser2(user) {
    this.selectedUsers2 = this.selectedUsers2.filter(
      (selectedUser) => selectedUser.id !== user.id,
    );
    this.usuariosFiltrados2.push(JSON.parse(JSON.stringify(user)));
    //ordenar por nombre
    this.usuariosFiltrados2.sort((a, b) => a.nombre.localeCompare(b.nombre));
  }

  removeUser3(user) {
    this.selectedUsers3 = this.selectedUsers3.filter(
      (selectedUser) => selectedUser.id !== user.id,
    );
    this.usuariosFiltrados3.push(JSON.parse(JSON.stringify(user)));
    //ordenar por nombre
    this.usuariosFiltrados3.sort((a, b) => a.nombre.localeCompare(b.nombre));
  }

  onFocus(event: FocusEvent) {
    const target = event.target as HTMLElement;
    this.renderer.addClass(target, 'focused');
  }

  onBlur(event: FocusEvent) {
    const target = event.target as HTMLElement;
    this.renderer.removeClass(target, 'focused');
  }

  onEditorCreated(quill: Quill) {
    // Guardar la referencia al editor para poder enfocarlo más tarde
    this.quillInstance = quill;

    // Agregar manejador para cuando el editor recibe foco
    quill.root.addEventListener('focus', () => {
      // Asegurarse de que el cursor se coloque en el editor
      setTimeout(() => {
        // Colocar el cursor al final del contenido
        const length = quill.getLength();
        quill.setSelection(length, 0);
      }, 0);
    });

    // Sobrescribir el handler de imágenes del editor para validar los tipos de archivo
    const toolbar = quill.getModule('toolbar');
    toolbar.addHandler('image', () => {
      // Crear un input de tipo file oculto
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*'); // Solo aceptar imágenes
      input.click();

      // Cuando se seleccione un archivo
      input.onchange = () => {
        if (input.files && input.files[0]) {
          const file = input.files[0];

          // Verificar que sea una imagen
          if (!file.type.match(/^image\/(png|jpe?g|gif|webp)$/i)) {
            // Mostrar mensaje de error si no es una imagen válida
            const title = this.translate.instant('imageTypeError');
            const message = this.translate.instant('imageTypeErrorMessage');
            this.openResultDialog(0, title, message);
            return;
          }

          // Verificar tamaño total con esta imagen
          const maxSize = 20 * 1024 * 1024; // 20MB
          const currentSize = this.calculateTotalEmailSize();
          if (currentSize + file.size > maxSize) {
            // Mostrar mensaje de error si excede el tamaño máximo
            const title = this.translate.instant('emailSizeExceeded');
            const message = this.translate.instant('emailSizeExceededMessage');
            this.openResultDialog(0, title, message);
            return;
          }

          // Si pasa las validaciones, cargar la imagen
          const reader = new FileReader();
          reader.onload = (e) => {
            const range = quill.getSelection(true);
            quill.insertEmbed(range.index, 'image', reader.result, 'user');
            quill.setSelection(range.index + 1, 0);
          };
          reader.readAsDataURL(file);
        }
      };
    });

    // Manejar pegado de imágenes
    quill.root.addEventListener('paste', (e: ClipboardEvent) => {
      // Detener la propagación inmediatamente para tener control total sobre el evento
      e.preventDefault();

      const clipboardData = e.clipboardData;
      if (!clipboardData?.items) {
        return;
      }

      let handled = false;
      for (let i = 0; i < clipboardData.items.length; i++) {
        const item = clipboardData.items[i];

        // Verificar si es una imagen
        if (item.type.indexOf('image') !== -1) {
          const file = item.getAsFile();
          if (!file) {
            continue;
          }

          // Marcar como manejado para evitar procesamiento adicional
          handled = true;

          // Verificar que sea un tipo de imagen válido
          if (!file.type.match(/^image\/(png|jpe?g|gif|webp)$/i)) {
            // Mostrar mensaje de error
            const title = this.translate.instant('imageTypeError');
            const message = this.translate.instant('imageTypeErrorMessage');
            this.openResultDialog(0, title, message);
            return;
          }

          // Verificar tamaño total con esta imagen
          const maxSize = 20 * 1024 * 1024; // 20MB
          const currentSize = this.calculateTotalEmailSize();
          if (currentSize + file.size > maxSize) {
            // Mostrar mensaje de error si excede el tamaño máximo
            const title = this.translate.instant('emailSizeExceeded');
            const message = this.translate.instant('emailSizeExceededMessage');
            if (!this.errorEmail) {
              this.errorEmail = true;
              const dialog = this.openResultDialog(0, title, message);

              dialog.afterClosed().subscribe(() => {
                this.errorEmail = false;
              });
            }
            return;
          }

          // Si pasa las validaciones, cargar la imagen
          const reader = new FileReader();
          reader.onload = (event: any) => {
            const base64Image = event.target.result;
            // Insertamos la imagen donde esté el cursor
            const range = quill.getSelection(true);
            quill.insertEmbed(range.index, 'image', base64Image, 'user');
          };
          reader.readAsDataURL(file);
          break;
        } else if (
          item.type.indexOf('application/') !== -1 ||
          (item.type.indexOf('text/html') !== -1 &&
            clipboardData.getData('text/html').includes('<img'))
        ) {
          // Si es un archivo que no es imagen o HTML con imágenes incrustadas
          // Solo permitir el pegado de texto plano
          handled = true;
          const plainText = clipboardData.getData('text/plain');
          if (plainText) {
            // Insertar como texto plano
            const range = quill.getSelection(true);
            quill.insertText(range.index, plainText, 'user');
          }
          break;
        }
      }

      // Si no se manejó ningún caso especial, permitir el pegado de texto plano
      if (!handled) {
        const plainText = clipboardData.getData('text/plain');
        if (plainText) {
          const range = quill.getSelection(true);
          quill.insertText(range.index, plainText, 'user');
        }
      }
    });
  }

  activeActionCC() {
    this.activeCC = true;
  }

  validateEmail(email: string): boolean {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }

  openResponseDialog(response: string, message?: string) {
    let data: string[] = [];
    if (response == 'Error') {
      data.push('Error');
      data.push(message);
      const dialogRef = this.dialog.open(ResponseDialogComponent, {
        width: '500px',
        /* height: '400px', */
        data: data,
      });
      return dialogRef;
    } else if (response == 'Exito') {
      data.push('Exito');
      data.push(message);

      const dialogRef = this.dialog.open(ResponseDialogComponent, {
        width: '500px',
        /* height: '400px', */
        data: data,
      });
      return dialogRef;
    }
  }

  openResultDialog(mode: number, message?: string, content?: string) {
    let data: string[] = [];
    switch (mode) {
      case 0:
        {
          data.push('Error');
          data.push(message);
          if (content) data.push(content);
          return this.dialog.open(ResponseSmallDialogComponent, {
            width: '500px',
            data: data,
          });
        }
        break;
      case 1:
        {
          data.push('Exito');
          data.push(message);
          if (content) data.push(content);
          return this.dialog.open(ResponseSmallDialogComponent, {
            width: '500px',
            data: data,
          });
        }
        break;
      case 2:
        {
          data.push('loading');
          data.push(message);
          if (content) data.push(content);
          return this.dialog.open(ResponseSmallDialogComponent, {
            width: '500px',
            data: data,
            disableClose: true,
          });
        }
        break;
    }
  }

  onCVTypeChange(event: MatSelectChange) {
    this.selectedCVType = event.value;
  }

  getPermission(permission: string | string[]): boolean {
    if (typeof permission === 'string') {
      return this.userPermissions.includes(permission);
    } else {
      for (let i = 0; i < permission.length; i++) {
        if (this.userPermissions.includes(permission[i])) {
          return true;
        }
      }
    }
  }

  /**
   * Calcula el tamaño aproximado del contenido del editor Quill en bytes
   * Incluye texto y las imágenes incrustadas en base64
   */
  calculateQuillContentSize(): number {
    if (!this.quillInstance) {
      return 0;
    }

    let contentSize = 0;
    const bodyHtml = this.miFormulario.get('message').value || '';

    // Tamaño del texto (aproximado: 1 carácter = 1 byte en UTF-8 para caracteres ASCII)
    // Para texto sin formato, eliminamos las etiquetas HTML
    const textContent = bodyHtml.replace(/<[^>]*>/g, '').trim();
    contentSize += textContent.length;

    // Extraer y calcular el tamaño de las imágenes base64
    const imageRegex =
      /<img([^>]+)src=["'](data:image\/(png|jpeg|jpg|gif);base64,([^"']+))["']([^>]*)>/g;
    let match;

    while ((match = imageRegex.exec(bodyHtml)) !== null) {
      // El grupo 4 contiene los datos base64 sin el prefijo
      const base64Data = match[4];
      // Calcular el tamaño aproximado de la imagen en bytes
      // La longitud de los datos base64 * 0.75 da el tamaño aproximado en bytes
      contentSize += Math.ceil(base64Data.length * 0.75);
    }

    return contentSize;
  }

  /**
   * Calcula el tamaño total del email (contenido del editor)
   */
  calculateTotalEmailSize(): number {
    // Tamaño del contenido del editor Quill
    const quillContentSize = this.calculateQuillContentSize();

    // Tamaño total = contenido del editor + otros datos (asunto, destinatarios, etc.)
    // Estimamos 1KB para los metadatos del email
    const metadataSize = 1024;

    return quillContentSize + metadataSize;
  }

  /**
   * Maneja los cambios en el contenido del editor Quill
   * Verifica si se excede el límite de tamaño
   */
  onContentChanged(event: any): void {
    // Si estamos restaurando contenido, no hacer nada para evitar ciclos infinitos
    if (this.isRestoringContent) {
      return;
    }

    const maxSize = 20 * 1024 * 1024; // 20MB en bytes
    const totalSize = this.calculateTotalEmailSize();

    // Si el tamaño total supera el límite, revertir el último cambio
    if (totalSize > maxSize) {
      // Obtener el contenido anterior al último cambio
      const previousContent = event.oldDelta;

      // Si hay un cambio previo disponible, restaurarlo
      if (previousContent) {
        // Activar la bandera para evitar ciclos infinitos
        this.isRestoringContent = true;

        // Mostrar mensaje de advertencia solo una vez
        const title = this.translate.instant('emailSizeExceeded');
        const message = this.translate.instant('emailSizeExceededMessage');
        if (!this.errorEmail) {
          this.errorEmail = true;
          const dialog = this.openResultDialog(0, title, message);

          dialog.afterClosed().subscribe(() => {
            this.errorEmail = false;
          });
        }

        // Restaurar el contenido anterior si el cambio actual excede el límite
        setTimeout(() => {
          // Usar setTimeout para asegurar que la restauración ocurra después de que se complete el ciclo actual
          this.quillInstance.setContents(previousContent);

          // Desactivar la bandera después de un breve retraso para permitir futuras ediciones
          setTimeout(() => {
            this.isRestoringContent = false;
          }, 100);
        }, 0);
      }
    }
  }

  // Método para enfocar el área editable del editor Quill
  focusQuillEditor() {
    if (this.quillInstance) {
      // Dar foco al área editable
      this.quillInstance.focus();

      // Colocar el cursor al final del contenido
      const length = this.quillInstance.getLength();
      this.quillInstance.setSelection(length, 0);
    }
  }
}
